export const dashboardFilterConfig = [
  {
    key: 'dashboardFuel',
    label: 'dashboard.tab.fuel',
    modal: 'dashboardFuelModal',
    filter: {
      vehicleGroupId: {
        value: [],
      },
      vehicleTypeId: {
        value: [],
      },
    },
  },
]
